import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HandleAlertsProvider} from '../../../utils/providers/handle-alerts-provider';
import Swal from 'sweetalert2';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CreateLinkComponent } from '../../alerts/header-links/create-link/create-link.component';

@Component({
  selector: 'app-header-links-grid',
  templateUrl: './header-links-grid.component.html',
  styleUrls: ['./header-links-grid.component.scss']
})
export class HeaderLinksGridComponent implements OnInit {
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() mantenienceSection;
  @Input() mantenienceMedata;
  @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusField: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    private handleAlertsProvider: HandleAlertsProvider,
    private serviceModal: NgbModal,
  ) {
  }

  ngOnInit(): void {
  }

  delete(item) {
    if (this.activeArrData.length === 1) {
      Swal.fire({
        title: 'Oops...',
        text: 'No Puedes Eliminar Todos los items en esta sección!',
        icon: 'error',
      });
    } else {
      Swal.fire({
        title: `¿Desea eliminar <br> <b>${item.value}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedData.emit(item.id);
        }
      });
    }
  }

  editLink(menu): any {
    const modal = this.serviceModal.open(CreateLinkComponent, {
      centered: true,
      windowClass: 'custom-modal-benefit d-flex flex-column w-100 justify-content-center h-100pr',
    });
    modal.componentInstance.linkInfo = menu;
    modal.result.then((res) => {
      this.editedData.emit(res);
    }, (reason) => {
      
    });

    // const dialogRef = this.handleAlertsProvider.getEditNavLink(
    //   navLink.id,
    //   navLink.value,
    //   navLink.img,
    //   navLink.url,
    //   navLink.urlExterno === false ? 0 : 1,
    //   navLink.imgActivo === false ? 0 : 1,
    //   navLink.detail,
    // );
    // dialogRef.afterClosed().subscribe(res => {
    //   if (res) {
    //     this.editedData.emit(res);
    //   }
    // });
  }

  changeStatus(navLink: any): any {
    this.statusField.emit({
      id: navLink.id,
      title: navLink.value,
      status: navLink.status,
    });
  }

}
